import { Offcanvas } from "react-bootstrap";
import FormInput from "../../../components/forms/FormInput";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { toast } from "react-toastify";
import { useSendEnquiryMutation } from "../../../features/users/usersApi";

const schema = Yup.object({
  text: Yup.string()
    .required("Enquiry text is required")
    .min(10, "Enquiry text must be at least 10 characters long"),
});

interface BookCallModalProps {
  show: boolean;
  onHide: () => void;
}

const BookCallModal: React.FC<BookCallModalProps> = ({ show, onHide }) => {
  const [sendEnquiry, { isLoading }] = useSendEnquiryMutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      text: "",
    },
  });

  const onSubmit = async (data: { text: string }) => {
    try {
      await sendEnquiry({ source: "plan", message: data.text }).unwrap();
      toast.success("Request sent successfully!");
      reset();
      onHide();
    } catch (e) {
      console.log({ e });
      toast.error("Failed to send request. Please try again.");
    }
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Send request</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div>
            <div>
              <FormInput
                register={register}
                label="How can we help?"
                name="text"
                type="textarea"
                rows="7"
                placeholder="Tell us what you'd like to change about your plan or billing."
                errors={errors}
              />
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="btn btn-primary mt-2"
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Send request"}
              </button>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default BookCallModal;
